export function LogoIcon({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="45"
        height="43"
        viewBox="0 0 45 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_453_9585)">
          <path
            d="M39.7946 16.5417L42.8981 14.7123L37.6634 6.85136L36.1226 7.8182C32.2431 10.2534 27.196 7.42861 27.2761 2.86657L27.2959 1.74609H17.7493L17.7592 2.91925C17.7987 7.47031 12.7505 10.2534 8.89084 7.80722L7.38186 6.85026L2.04395 14.7112L5.1848 16.5636C8.97424 18.798 8.9479 24.261 5.13871 26.4603L2.1471 28.1866L7.38186 36.2516L8.95449 35.2793C12.8361 32.8803 17.8481 35.7095 17.7669 40.254L17.7493 41.2537H27.2959L27.2805 40.3802C27.1993 35.8313 32.2201 33.0021 36.1017 35.4099L37.4592 36.2516L42.8992 28.1866L39.8615 26.4493C36.0348 24.26 35.9986 18.7816 39.7957 16.5417H39.7946ZM22.4705 27.426C19.1979 27.426 16.5443 24.7725 16.5443 21.4999C16.5443 18.2274 19.1979 15.5738 22.4705 15.5738C25.743 15.5738 28.3966 18.2274 28.3966 21.4999C28.3966 24.7725 25.743 27.426 22.4705 27.426Z"
            fill="#6466F1"
          />
          <path
            d="M27.7422 41.6931H17.3023L17.3276 40.2466C17.3627 38.2844 16.3607 36.5307 14.6477 35.5562C12.9192 34.5718 10.8769 34.608 9.18463 35.6539L7.24656 36.8523L1.52564 28.0377L4.91781 26.0799C6.57054 25.1262 7.56262 23.423 7.5714 21.5233C7.58018 19.6237 6.60456 17.9117 4.96061 16.9415L1.41699 14.852L7.25644 6.25253L9.12537 7.43666C10.8077 8.50227 12.8512 8.56153 14.5917 7.5936C16.3169 6.63444 17.3364 4.88842 17.3199 2.92402L17.3056 1.30859H27.7411L27.7137 2.87573C27.6797 4.84562 28.6871 6.60152 30.4101 7.57494C32.1495 8.55605 34.1973 8.50886 35.8874 7.44764L37.7903 6.25363L43.5189 14.8553L40.0159 16.9207C38.3687 17.8919 37.3931 19.6083 37.4051 21.5124C37.4172 23.4164 38.4159 25.1196 40.0763 26.07L43.5244 28.0421L37.5829 36.849L35.8665 35.7845C34.1743 34.7353 32.1309 34.6958 30.3991 35.6802C28.6838 36.6547 27.6808 38.4095 27.7159 40.3739L27.74 41.6953L27.7422 41.6931ZM18.1957 40.8151H26.8478L26.8401 40.3882C26.7995 38.0979 27.9683 36.0512 29.9678 34.9153C31.9838 33.7696 34.362 33.8157 36.3318 35.0371L37.3305 35.6561L42.2701 28.3329L39.6428 26.8305C37.708 25.7232 36.5448 23.7368 36.5294 21.5167C36.5151 19.2966 37.6521 17.2949 39.5715 16.1635L42.2756 14.5689L37.5346 7.44983L36.356 8.1895C34.3883 9.42521 32.0047 9.48009 29.9799 8.33766C27.9716 7.20401 26.7973 5.1562 26.8369 2.85927L26.8489 2.18544H18.1924L18.199 2.91524C18.2187 5.20668 17.0302 7.24242 15.0197 8.3607C12.9927 9.48667 10.6146 9.41863 8.65676 8.17853L7.50665 7.44983L2.66916 14.5711L5.40726 16.1854C7.32228 17.3147 8.46032 19.312 8.44935 21.5266C8.43947 23.7423 7.28278 25.7287 5.35678 26.8404L2.76574 28.3362L7.51543 35.6528L8.72371 34.9065C10.6925 33.6895 13.0695 33.6467 15.0822 34.7924C17.0785 35.9293 18.2461 37.9739 18.2055 40.262L18.1957 40.8151ZM22.4702 27.8654C18.9606 27.8654 16.105 25.0099 16.105 21.5003C16.105 17.9907 18.9606 15.1352 22.4702 15.1352C25.9798 15.1352 28.8353 17.9907 28.8353 21.5003C28.8353 25.0099 25.9798 27.8654 22.4702 27.8654ZM22.4702 16.0131C19.4445 16.0131 16.983 18.4747 16.983 21.5003C16.983 24.5259 19.4445 26.9874 22.4702 26.9874C25.4958 26.9874 27.9573 24.5259 27.9573 21.5003C27.9573 18.4747 25.4958 16.0131 22.4702 16.0131Z"
            fill={color}
          />
          <path d="M18.6844 0.758301H16.709V2.73368H18.6844V0.758301Z" fill={color} />
          <path d="M28.2322 0.758301H26.2568V2.73368H28.2322V0.758301Z" fill={color} />
          <path d="M18.6844 40.2661H16.709V42.2415H18.6844V40.2661Z" fill={color} />
          <path d="M28.2322 40.2661H26.2568V42.2415H28.2322V40.2661Z" fill={color} />
          <path d="M39.0243 6.99379L37.9229 5.354L36.2831 6.45548L37.3845 8.09526L39.0243 6.99379Z" fill={color} />
          <path d="M44.3476 14.9201L43.2461 13.2803L41.6063 14.3817L42.7078 16.0215L44.3476 14.9201Z" fill={color} />
          <path d="M3.45051 28.5074L2.34961 26.8672L0.709441 27.9681L1.81034 29.6083L3.45051 28.5074Z" fill={color} />
          <path d="M8.76985 36.4346L7.66895 34.7944L6.02878 35.8953L7.12968 37.5355L8.76985 36.4346Z" fill={color} />
          <path d="M1.77808 13.2465L0.657227 14.873L2.28382 15.9939L3.40468 14.3673L1.77808 13.2465Z" fill={color} />
          <path d="M7.19507 5.38512L6.07422 7.01172L7.70081 8.13257L8.82167 6.50598L7.19507 5.38512Z" fill={color} />
          <path d="M37.1589 35.0132L36.0557 36.6519L37.6943 37.755L38.7975 36.1164L37.1589 35.0132Z" fill={color} />
          <path d="M42.4919 27.0918L41.3887 28.7305L43.0273 29.8337L44.1305 28.195L42.4919 27.0918Z" fill={color} />
          <path d="M23.451 14.6958H21.4756V16.6712H23.451V14.6958Z" fill={color} />
          <path d="M23.451 26.4385H21.4756V28.4139H23.451V26.4385Z" fill={color} />
          <path d="M29.3777 20.5122H27.4023V22.4876H29.3777V20.5122Z" fill={color} />
          <path d="M17.5252 20.5122H15.5498V22.4876H17.5252V20.5122Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_453_9585">
            <rect width="43.6877" height="41.483" fill={color} transform="translate(0.65625 0.758301)" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export function LogoFooter({ className = "" }: { className?: string }) {
  return (
    <>
      <svg
        width="193"
        height="33"
        viewBox="0 0 193 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_453_10840)">
          <path
            d="M189.27 9.60771L191.16 8.49408L187.973 3.70884L187.035 4.29739C184.673 5.77979 181.601 4.06023 181.65 1.28315L181.662 0.601074H175.85L175.857 1.31522C175.881 4.08562 172.808 5.77979 170.458 4.29071L169.539 3.70817L166.29 8.49341L168.202 9.62108C170.509 10.9812 170.493 14.3068 168.174 15.6455L166.353 16.6964L169.539 21.6059L170.497 21.014C172.86 19.5536 175.911 21.2759 175.861 24.0423L175.85 24.6508H181.662L181.652 24.1191C181.603 21.35 184.659 19.6278 187.022 21.0935L187.849 21.6059L191.16 16.6964L189.311 15.6389C186.982 14.3061 186.959 10.9712 189.271 9.60771H189.27ZM178.724 16.2334C176.732 16.2334 175.117 14.6181 175.117 12.626C175.117 10.6338 176.732 9.01849 178.724 9.01849C180.717 9.01849 182.332 10.6338 182.332 12.626C182.332 14.6181 180.717 16.2334 178.724 16.2334Z"
            fill="white"
            fillOpacity="0.3"
          />
          <path
            d="M181.933 24.9185H175.578L175.594 24.038C175.615 22.8435 175.005 21.776 173.962 21.1828C172.91 20.5835 171.667 20.6056 170.637 21.2422L169.457 21.9717L165.974 16.606L168.039 15.4142C169.045 14.8336 169.649 13.7968 169.655 12.6404C169.66 11.484 169.066 10.4419 168.065 9.85132L165.908 8.57936L169.463 3.34452L170.601 4.06535C171.625 4.71402 172.869 4.7501 173.928 4.16088C174.978 3.577 175.599 2.51414 175.589 1.31833L175.58 0.334961H181.933L181.916 1.28894C181.895 2.48808 182.509 3.55696 183.557 4.14952C184.616 4.74676 185.863 4.71803 186.892 4.07203L188.05 3.34519L191.537 8.58136L189.405 9.83863C188.402 10.4299 187.808 11.4747 187.816 12.6337C187.823 13.7928 188.431 14.8296 189.442 15.4082L191.541 16.6086L187.924 21.9697L186.879 21.3217C185.849 20.6831 184.605 20.659 183.551 21.2583C182.507 21.8515 181.896 22.9197 181.917 24.1155L181.932 24.9198L181.933 24.9185ZM176.122 24.3841H181.389L181.384 24.1242C181.36 22.73 182.071 21.4841 183.288 20.7926C184.515 20.0952 185.963 20.1232 187.162 20.8668L187.77 21.2436L190.777 16.7857L189.178 15.8711C188 15.1971 187.292 13.9879 187.282 12.6364C187.274 11.285 187.966 10.0664 189.134 9.37768L190.78 8.407L187.894 4.07336L187.177 4.52363C185.979 5.27585 184.528 5.30926 183.296 4.61382C182.073 3.92372 181.358 2.67714 181.382 1.27891L181.39 0.868732H176.12L176.124 1.31298C176.136 2.70787 175.413 3.9471 174.189 4.62784C172.955 5.31326 171.507 5.27184 170.315 4.51695L169.615 4.07336L166.67 8.40834L168.337 9.39104C169.503 10.0785 170.196 11.2943 170.189 12.6424C170.183 13.9912 169.479 15.2004 168.306 15.8771L166.729 16.7877L169.621 21.2416L170.356 20.7873C171.555 20.0464 173.002 20.0204 174.227 20.7178C175.442 21.4099 176.153 22.6545 176.128 24.0474L176.122 24.3841ZM178.724 16.5011C176.588 16.5011 174.849 14.7628 174.849 12.6264C174.849 10.49 176.588 8.75171 178.724 8.75171C180.86 8.75171 182.599 10.49 182.599 12.6264C182.599 14.7628 180.86 16.5011 178.724 16.5011ZM178.724 9.28615C176.882 9.28615 175.384 10.7846 175.384 12.6264C175.384 14.4682 176.882 15.9666 178.724 15.9666C180.566 15.9666 182.064 14.4682 182.064 12.6264C182.064 10.7846 180.566 9.28615 178.724 9.28615Z"
            fill="white"
          />
          <path d="M176.419 0H175.217V1.20249H176.419V0Z" fill="white" />
          <path d="M182.231 0H181.028V1.20249H182.231V0Z" fill="white" />
          <path d="M176.419 24.0498H175.217V25.2523H176.419V24.0498Z" fill="white" />
          <path d="M182.232 24.0498H181.029V25.2523H182.232V24.0498Z" fill="white" />
          <path d="M188.8 3.79605L188.13 2.79785L187.132 3.46836L187.802 4.46656L188.8 3.79605Z" fill="white" />
          <path d="M192.042 8.62076L191.371 7.62256L190.373 8.29307L191.043 9.29126L192.042 8.62076Z" fill="white" />
          <path d="M167.145 16.892L166.475 15.8936L165.476 16.5637L166.146 17.5621L167.145 16.892Z" fill="white" />
          <path d="M170.384 21.7172L169.714 20.7188L168.715 21.3889L169.386 22.3873L170.384 21.7172Z" fill="white" />
          <path d="M166.128 7.60163L165.445 8.5918L166.435 9.2741L167.118 8.28393L166.128 7.60163Z" fill="white" />
          <path d="M169.424 2.81647L168.742 3.80664L169.732 4.48895L170.415 3.49878L169.424 2.81647Z" fill="white" />
          <path d="M187.665 20.8516L186.993 21.8491L187.991 22.5207L188.662 21.5232L187.665 20.8516Z" fill="white" />
          <path d="M190.912 16.0294L190.24 17.0269L191.238 17.6984L191.909 16.7009L190.912 16.0294Z" fill="white" />
          <path d="M179.321 8.48438H178.118V9.68686H179.321V8.48438Z" fill="white" />
          <path d="M179.321 15.6323H178.118V16.8348H179.321V15.6323Z" fill="white" />
          <path d="M182.928 12.0249H181.726V13.2274H182.928V12.0249Z" fill="white" />
          <path d="M175.713 12.0249H174.511V13.2274H175.713V12.0249Z" fill="white" />
        </g>
        <path
          d="M0.208984 1.05957H11.6229C16.4755 1.05957 19.7904 3.75927 19.7904 7.68922C19.7904 9.73962 18.6626 11.5166 16.8514 12.6785C19.1411 13.7379 20.5763 15.6858 20.5763 18.0096C20.5763 22.1787 17.1932 24.981 12.1697 24.981H0.208984V1.05957ZM11.3153 10.7629C13.2974 10.7629 14.5618 9.70355 14.5618 8.06322C14.5618 6.4229 13.2974 5.36352 11.3153 5.36352H5.43752V10.7629H11.3153ZM11.7938 20.6732C13.9125 20.6732 15.2795 19.5113 15.2795 17.7343C15.2795 15.9573 13.9125 14.8296 11.7938 14.8296H5.43752V20.6732H11.7938Z"
          fill="white"
        />
        <path
          d="M23.1738 18.1786V7.10645H28.0948V17.461C28.0948 19.6481 29.4959 21.0834 31.683 21.0834C33.2208 21.0834 34.4169 20.4683 35.237 19.4089V7.10645H40.158V24.9791H35.237V23.6122C33.9043 24.7399 32.1956 25.3209 30.2819 25.3209C26.0786 25.3209 23.1738 22.382 23.1738 18.1786Z"
          fill="white"
        />
        <path d="M52.3232 1.05943L57.2442 0.273438V24.9789H52.3232V1.05943Z" fill="white" />
        <path
          d="M63.3275 19.8189V11.2072H59.6709V7.10638H63.3275V2.49297L68.2484 1.43359V7.10638H73.3403V11.2072H68.2484V18.8279C68.2484 20.4682 68.8977 21.0833 70.7089 21.0833C71.5974 21.0833 72.2809 20.9808 73.2036 20.6732V24.7057C72.1784 25.0133 70.538 25.2525 69.5128 25.2525C65.4462 25.2525 63.3275 23.4071 63.3275 19.8189Z"
          fill="white"
        />
        <path
          d="M75.9033 1.05957H87.7273C92.6141 1.05957 96.0315 4.13518 96.0315 8.54355C96.0315 11.5508 94.2203 14.0455 91.4522 15.2074L96.7149 24.981H90.8713L86.2237 15.9592H81.1319V24.981H75.9033V1.05957ZM87.2489 11.6856C89.3676 11.6856 90.7688 10.4554 90.7688 8.61C90.7688 6.76463 89.3676 5.53439 87.2489 5.53439H81.1319V11.6856H87.2489Z"
          fill="white"
        />
        <path d="M98.9355 9.43408H103.857V24.9809H98.9355V9.43408Z" fill="white" />
        <path d="M43.7549 9.43213H48.6759V24.979H43.7549V9.43213Z" fill="white" />
        <path
          d="M108.983 30.6861L110.692 26.8245C112.674 27.7813 114.519 28.2597 116.399 28.2597C119.132 28.2597 120.534 27.0978 120.534 24.8082V23.5096C119.132 24.5007 117.492 25.0474 115.715 25.0474C110.657 25.0474 106.659 21.0492 106.659 15.9231C106.659 10.7971 110.726 6.83301 115.886 6.83301C117.595 6.83301 119.235 7.31144 120.602 8.19995V7.1064H125.489V24.8766C125.489 29.6609 122.311 32.2922 116.501 32.2922C113.699 32.2922 111.102 31.7113 108.983 30.6861ZM120.534 19.3747V12.5741C119.543 11.6173 118.141 11.0363 116.535 11.0363C113.699 11.0363 111.512 13.1551 111.512 15.9231C111.512 18.6912 113.699 20.9125 116.535 20.9125C118.176 20.9125 119.543 20.3657 120.534 19.3747Z"
          fill="white"
        />
        <path
          d="M129.077 1.05938L133.998 0V8.47501C135.331 7.34729 137.04 6.76634 138.953 6.76634C143.122 6.76634 146.061 9.70525 146.061 13.9086V24.9808H141.106V14.5921C141.106 12.405 139.705 11.0038 137.552 11.0038C136.014 11.0038 134.818 11.5848 133.998 12.6783V24.9808H129.077V1.05938Z"
          fill="white"
        />
        <path
          d="M151.494 19.8189V11.2072H147.838V7.10638H151.494V2.49297L156.415 1.43359V7.10638H161.507V11.2072H156.415V18.8279C156.415 20.4682 157.065 21.0833 158.876 21.0833C159.764 21.0833 160.448 20.9808 161.371 20.6732V24.7057C160.345 25.0133 158.705 25.2525 157.68 25.2525C153.613 25.2525 151.494 23.4071 151.494 19.8189Z"
          fill="white"
        />
        <path d="M48.6758 2.31396L43.7549 2.31396V7.23494L48.6758 7.23494V2.31396Z" fill="white" />
        <g clipPath="url(#clip1_453_10840)">
          <path
            d="M102.483 0.773586L97.4033 2.13477L98.7645 7.21476L103.844 5.85358L102.483 0.773586Z"
            fill="white"
            fillOpacity="0.3"
          />
          <path
            d="M104.067 5.98163L98.6367 7.43668L97.1816 2.00635L102.612 0.551293L104.067 5.98163ZM98.8932 6.99247L103.623 5.72516L102.356 0.995512L97.6259 2.26282L98.8932 6.99247Z"
            fill="white"
          />
          <path d="M97.6926 1.63449L96.9043 1.8457L97.1155 2.63398L97.9038 2.42276L97.6926 1.63449Z" fill="white" />
          <path d="M102.773 0.273646L101.984 0.484863L102.196 1.27314L102.984 1.06192L102.773 0.273646Z" fill="white" />
          <path d="M99.0539 6.71456L98.2656 6.92578L98.4768 7.71406L99.2651 7.50284L99.0539 6.71456Z" fill="white" />
          <path d="M104.134 5.35372L103.346 5.56494L103.557 6.35322L104.345 6.142L104.134 5.35372Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_453_10840">
            <rect width="26.5944" height="25.2523" fill="white" transform="translate(165.445)" />
          </clipPath>
          <clipPath id="clip1_453_10840">
            <rect width="6.07527" height="6.07527" fill="white" transform="translate(96.9043 1.8457) rotate(-15)" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export function LogoFullColors({ className = "" }: { className?: string }) {
  return (
    <>
      <svg
        width="197"
        height="35"
        viewBox="0 0 197 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_453_11046)">
          <path
            d="M193.663 10.8039L195.598 9.66373L192.335 4.76432L191.375 5.36691C188.957 6.88468 185.811 5.12409 185.861 2.28075L185.873 1.5824H179.923L179.929 2.31358C179.954 5.15009 176.808 6.88468 174.402 5.36007L173.462 4.76363L170.135 9.66305L172.092 10.8176C174.454 12.2102 174.438 15.6151 172.064 16.9858L170.199 18.0618L173.462 23.0884L174.442 22.4824C176.861 20.9872 179.985 22.7505 179.934 25.5829L179.923 26.206H185.873L185.864 25.6616C185.813 22.8264 188.942 21.0631 191.362 22.5638L192.208 23.0884L195.598 18.0618L193.705 16.979C191.32 15.6144 191.297 12.2 193.664 10.8039H193.663ZM182.866 17.5877C180.826 17.5877 179.172 15.9339 179.172 13.8942C179.172 11.8546 180.826 10.2007 182.866 10.2007C184.906 10.2007 186.559 11.8546 186.559 13.8942C186.559 15.9339 184.906 17.5877 182.866 17.5877Z"
            fill="#6271F4"
          />
          <path
            d="M186.152 26.4796H179.645L179.661 25.5781C179.683 24.3551 179.058 23.2621 177.99 22.6547C176.913 22.0412 175.64 22.0637 174.585 22.7156L173.377 23.4625L169.812 17.9687L171.926 16.7485C172.956 16.1541 173.574 15.0925 173.58 13.9085C173.585 12.7245 172.977 11.6575 171.953 11.0529L169.744 9.75056L173.384 4.39082L174.548 5.12884C175.597 5.793 176.871 5.82993 177.955 5.22666C179.031 4.62885 179.666 3.54062 179.656 2.31628L179.647 1.30945H186.151L186.134 2.28619C186.113 3.51395 186.741 4.60833 187.814 5.21503C188.899 5.82651 190.175 5.7971 191.228 5.13569L192.414 4.3915L195.985 9.75261L193.801 11.0399C192.775 11.6452 192.167 12.715 192.174 13.9017C192.182 15.0884 192.804 16.15 193.839 16.7423L195.988 17.9714L192.285 23.4604L191.215 22.797C190.161 22.1431 188.887 22.1185 187.808 22.732C186.739 23.3394 186.113 24.4331 186.135 25.6574L186.15 26.4809L186.152 26.4796ZM180.202 25.9324H185.594L185.589 25.6663C185.564 24.2388 186.293 22.9632 187.539 22.2553C188.795 21.5412 190.278 21.5699 191.505 22.3312L192.128 22.7169L195.206 18.1527L193.569 17.2163C192.363 16.5262 191.638 15.2881 191.628 13.9044C191.619 12.5207 192.328 11.2731 193.524 10.5679L195.21 9.57409L192.255 5.13705L191.52 5.59806C190.294 6.36823 188.808 6.40243 187.546 5.6904C186.295 4.98384 185.563 3.70752 185.587 2.27593L185.595 1.85596H180.2L180.204 2.31081C180.216 3.73898 179.475 5.00778 178.222 5.70476C176.959 6.40654 175.477 6.36413 174.256 5.59122L173.54 5.13705L170.525 9.57546L172.231 10.5816C173.425 11.2854 174.134 12.5303 174.127 13.9106C174.121 15.2916 173.4 16.5296 172.2 17.2225L170.585 18.1547L173.545 22.7149L174.298 22.2498C175.525 21.4912 177.007 21.4646 178.261 22.1786C179.505 22.8873 180.233 24.1615 180.208 25.5877L180.202 25.9324ZM182.866 17.8613C180.678 17.8613 178.899 16.0816 178.899 13.8942C178.899 11.7068 180.678 9.92703 182.866 9.92703C185.053 9.92703 186.833 11.7068 186.833 13.8942C186.833 16.0816 185.053 17.8613 182.866 17.8613ZM182.866 10.4742C180.98 10.4742 179.446 12.0084 179.446 13.8942C179.446 15.7799 180.98 17.3141 182.866 17.3141C184.752 17.3141 186.286 15.7799 186.286 13.8942C186.286 12.0084 184.752 10.4742 182.866 10.4742Z"
            fill="#4A4CEE"
          />
          <path d="M180.507 0.966797H179.275V2.19798H180.507V0.966797Z" fill="#4A4CEE" />
          <path d="M186.457 0.966797H185.226V2.19798H186.457V0.966797Z" fill="#4A4CEE" />
          <path d="M180.507 25.5905H179.275V26.8216H180.507V25.5905Z" fill="#4A4CEE" />
          <path d="M186.458 25.5905H185.227V26.8216H186.458V25.5905Z" fill="#4A4CEE" />
          <path d="M193.184 4.85295L192.497 3.83093L191.475 4.51744L192.162 5.53945L193.184 4.85295Z" fill="#4A4CEE" />
          <path d="M196.501 9.79326L195.814 8.77124L194.792 9.45775L195.479 10.4798L196.501 9.79326Z" fill="#4A4CEE" />
          <path d="M171.011 18.2618L170.325 17.2395L169.303 17.9257L169.989 18.9479L171.011 18.2618Z" fill="#4A4CEE" />
          <path d="M174.327 23.2023L173.641 22.1801L172.618 22.8662L173.305 23.8885L174.327 23.2023Z" fill="#4A4CEE" />
          <path d="M169.969 8.75L169.271 9.76379L170.284 10.4624L170.983 9.44859L169.969 8.75Z" fill="#4A4CEE" />
          <path d="M173.345 3.85022L172.646 4.86401L173.66 5.5626L174.359 4.54881L173.345 3.85022Z" fill="#4A4CEE" />
          <path d="M192.021 22.316L191.333 23.3373L192.354 24.0249L193.042 23.0036L192.021 22.316Z" fill="#4A4CEE" />
          <path d="M195.345 17.3789L194.657 18.4001L195.679 19.0877L196.366 18.0664L195.345 17.3789Z" fill="#4A4CEE" />
          <path d="M183.478 9.65344H182.247V10.8846H183.478V9.65344Z" fill="#4A4CEE" />
          <path d="M183.478 16.972H182.247V18.2032H183.478V16.972Z" fill="#4A4CEE" />
          <path d="M187.172 13.2786H185.94V14.5097H187.172V13.2786Z" fill="#4A4CEE" />
          <path d="M179.784 13.2786H178.553V14.5097H179.784V13.2786Z" fill="#4A4CEE" />
        </g>
        <path
          d="M0.0917969 2.05139H11.7781C16.7465 2.05139 20.1404 4.81551 20.1404 8.83923C20.1404 10.9386 18.9858 12.758 17.1314 13.9476C19.4756 15.0322 20.9451 17.0266 20.9451 19.4059C20.9451 23.6745 17.4812 26.5436 12.3379 26.5436H0.0917969V2.05139ZM11.4632 11.9863C13.4925 11.9863 14.7871 10.9016 14.7871 9.22216C14.7871 7.5427 13.4925 6.45804 11.4632 6.45804H5.44509V11.9863H11.4632ZM11.953 22.133C14.1223 22.133 15.5219 20.9434 15.5219 19.124C15.5219 17.3046 14.1223 16.1499 11.953 16.1499H5.44509V22.133H11.953Z"
          fill="black"
        />
        <path
          d="M23.6045 19.5789V8.24255H28.6429V18.8442C28.6429 21.0835 30.0774 22.553 32.3167 22.553C33.8912 22.553 35.1158 21.9232 35.9556 20.8385V8.24255H40.9939V26.5417H35.9556V25.1422C34.591 26.2968 32.8415 26.8916 30.8822 26.8916C26.5785 26.8916 23.6045 23.8826 23.6045 19.5789Z"
          fill="black"
        />
        <path d="M53.4502 2.05145L58.4886 1.2467V26.5417H53.4502V2.05145Z" fill="black" />
        <path
          d="M64.7165 21.2583V12.4411H60.9727V8.24247H64.7165V3.51898L69.7549 2.43433V8.24247H74.9682V12.4411H69.7549V20.2436C69.7549 21.9231 70.4196 22.5529 72.274 22.5529C73.1838 22.5529 73.8835 22.4479 74.8282 22.133V26.2617C73.7786 26.5766 72.0991 26.8215 71.0494 26.8215C66.8858 26.8215 64.7165 24.9321 64.7165 21.2583Z"
          fill="black"
        />
        <path
          d="M77.5918 2.05139H89.6979C94.7013 2.05139 98.2002 5.20039 98.2002 9.71395C98.2002 12.793 96.3458 15.3471 93.5117 16.5368L98.9 26.5436H92.9169L88.1584 17.3065H82.9451V26.5436H77.5918V2.05139ZM89.2081 12.931C91.3774 12.931 92.8119 11.6714 92.8119 9.78198C92.8119 7.89258 91.3774 6.63299 89.2081 6.63299H82.9451V12.931H89.2081Z"
          fill="black"
        />
        <path d="M101.175 10.626H106.213V26.5438H101.175V10.626Z" fill="black" />
        <path d="M44.6768 10.624H49.7151V26.5418H44.6768V10.624Z" fill="black" />
        <path
          d="M111.461 32.3847L113.211 28.431C115.24 29.4107 117.129 29.9005 119.054 29.9005C121.853 29.9005 123.287 28.7109 123.287 26.3667V25.0371C121.853 26.0518 120.173 26.6116 118.354 26.6116C113.176 26.6116 109.082 22.5179 109.082 17.2696C109.082 12.0212 113.246 7.96252 118.529 7.96252C120.278 7.96252 121.958 8.45237 123.357 9.36208V8.24244H128.361V26.4366C128.361 31.3351 125.107 34.0292 119.159 34.0292C116.29 34.0292 113.631 33.4344 111.461 32.3847ZM123.287 20.8034V13.8406C122.273 12.861 120.838 12.2662 119.194 12.2662C116.29 12.2662 114.05 14.4355 114.05 17.2696C114.05 20.1037 116.29 22.3779 119.194 22.3779C120.873 22.3779 122.273 21.8181 123.287 20.8034Z"
          fill="black"
        />
        <path
          d="M132.035 2.05145L137.074 0.966797V9.64403C138.438 8.4894 140.188 7.89459 142.147 7.89459C146.416 7.89459 149.425 10.9036 149.425 15.2073V26.5436H144.351V15.907C144.351 13.6677 142.917 12.2332 140.712 12.2332C139.138 12.2332 137.913 12.828 137.074 13.9477V26.5436H132.035V2.05145Z"
          fill="black"
        />
        <path
          d="M154.988 21.2583V12.4411H151.244V8.24247H154.988V3.51898L160.026 2.43433V8.24247H165.24V12.4411H160.026V20.2436C160.026 21.9231 160.691 22.5529 162.546 22.5529C163.455 22.5529 164.155 22.4479 165.1 22.133V26.2617C164.05 26.5766 162.371 26.8215 161.321 26.8215C157.157 26.8215 154.988 24.9321 154.988 21.2583Z"
          fill="black"
        />
        <path d="M49.7151 3.33618L44.6768 3.33618V8.37457H49.7151V3.33618Z" fill="black" />
        <g clipPath="url(#clip1_453_11046)">
          <path d="M104.808 1.75832L99.6064 3.15198L101 8.35318L106.201 6.95952L104.808 1.75832Z" fill="#6271F4" />
          <path
            d="M106.429 7.09077L100.869 8.58054L99.3789 3.02063L104.939 1.53086L106.429 7.09077ZM101.131 8.12572L105.974 6.82818L104.676 1.98568L99.8337 3.28322L101.131 8.12572Z"
            fill="#4A4CEE"
          />
          <path d="M99.9018 2.64031L99.0947 2.85657L99.311 3.66365L100.118 3.44739L99.9018 2.64031Z" fill="#4A4CEE" />
          <path d="M105.103 1.24676L104.296 1.46301L104.512 2.2701L105.319 2.05384L105.103 1.24676Z" fill="#4A4CEE" />
          <path d="M101.295 7.8416L100.488 8.05786L100.705 8.86494L101.512 8.64869L101.295 7.8416Z" fill="#4A4CEE" />
          <path d="M106.497 6.44781L105.689 6.66406L105.906 7.47115L106.713 7.25489L106.497 6.44781Z" fill="#4A4CEE" />
        </g>
        <defs>
          <clipPath id="clip0_453_11046">
            <rect width="27.2289" height="25.8548" fill="white" transform="translate(169.271 0.966797)" />
          </clipPath>
          <clipPath id="clip1_453_11046">
            <rect width="6.22024" height="6.22024" fill="white" transform="translate(99.0947 2.85657) rotate(-15)" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export function IconQuotes({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="44"
        height="30"
        viewBox="0 0 44 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M22.5773 0.238281L14.9759 29.169H0L11.6857 0.238281H22.5773ZM43.3393 0.238281L35.7379 29.169H20.6486L32.4478 0.238281H43.3393Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function IconTwoSquares({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_453_10770)">
          <path
            d="M17.2787 8.20859H9.61032C8.66919 8.20859 7.90625 8.97153 7.90625 9.91266V17.581C7.90625 18.5221 8.66919 19.2851 9.61032 19.2851H17.2787C18.2198 19.2851 18.9827 18.5221 18.9827 17.581V9.91266C18.9827 8.97153 18.2198 8.20859 17.2787 8.20859Z"
            stroke={color}
            strokeWidth="1.70407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.49849 13.3208H3.64646C3.19451 13.3208 2.76107 13.1413 2.44149 12.8217C2.12192 12.5021 1.94238 12.0687 1.94238 11.6167V3.94841C1.94238 3.49646 2.12192 3.06302 2.44149 2.74345C2.76107 2.42387 3.19451 2.24434 3.64646 2.24434H11.3148C11.7667 2.24434 12.2002 2.42387 12.5198 2.74345C12.8393 3.06302 13.0189 3.49646 13.0189 3.94841V4.80045"
            stroke={color}
            strokeWidth="1.70407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_453_10770">
            <rect width="20.4489" height="20.4489" fill={color} transform="translate(0.238281 0.540123)" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export function IconCheck({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M21.0389 8.25504L10.5829 18.711C10.4903 18.8044 10.3643 18.8569 10.2328 18.8569C10.1012 18.8569 9.97518 18.8044 9.88257 18.711L4.56581 13.3942C4.47244 13.3017 4.41992 13.1756 4.41992 13.044C4.41992 12.9125 4.47244 12.7865 4.56581 12.6939L5.2563 12.0034C5.34891 11.9101 5.47497 11.8575 5.60648 11.8575C5.73799 11.8575 5.86405 11.9101 5.95665 12.0034L10.2278 16.2745L19.6481 6.85434C19.8432 6.66515 20.1533 6.66515 20.3484 6.85434L21.0389 7.55469C21.1323 7.64729 21.1848 7.77336 21.1848 7.90487C21.1848 8.03637 21.1323 8.16243 21.0389 8.25504Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function IconChevronDown({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="28"
        height="16"
        viewBox="0 0 28 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M26 2L14 14L2 2" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );
}

export function IconArrowTRight({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="24"
        height="27"
        viewBox="0 0 24 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M24.0002 13.5L0.794922 0.0688477V26.9311L24.0002 13.5Z" fill={color} />
      </svg>
    </>
  );
}

export function IconStar({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.79202 2.79363C8.55119 2.21462 7.73096 2.21462 7.49014 2.79363L6.11704 6.09496L2.55298 6.38069C1.92789 6.4308 1.67442 7.21089 2.15068 7.61885L4.86611 9.94491L4.0365 13.4228C3.891 14.0328 4.55458 14.5149 5.08975 14.1881L8.14108 12.3243L11.1924 14.1881C11.7276 14.5149 12.3912 14.0328 12.2457 13.4228L11.416 9.94491L14.1315 7.61885C14.6077 7.21089 14.3543 6.4308 13.7292 6.38069L10.1651 6.09496L8.79202 2.79363Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function IconChat({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M21.3232 11.7187C21.3267 13.0386 21.0183 14.3406 20.4232 15.5187C19.7177 16.9305 18.633 18.1179 17.2907 18.948C15.9484 19.7781 14.4015 20.2181 12.8232 20.2187C11.5034 20.2222 10.2014 19.9138 9.02324 19.3187L3.32324 21.2187L5.22324 15.5187C4.62817 14.3406 4.3198 13.0386 4.32324 11.7187C4.32385 10.1405 4.76385 8.5936 5.59396 7.2513C6.42407 5.909 7.6115 4.82432 9.02324 4.11875C10.2014 3.52368 11.5034 3.21531 12.8232 3.21875H13.3232C15.4076 3.33374 17.3763 4.21351 18.8524 5.68961C20.3285 7.1657 21.2083 9.1344 21.3232 11.2187V11.7187Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function IconPhone({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M22.3237 17.1388V20.1388C22.3248 20.4173 22.2677 20.6929 22.1562 20.9481C22.0446 21.2033 21.881 21.4323 21.6757 21.6206C21.4705 21.8089 21.2282 21.9522 20.9644 22.0415C20.7006 22.1307 20.421 22.1638 20.1437 22.1388C17.0665 21.8044 14.1107 20.7529 11.5137 19.0688C9.09749 17.5334 7.049 15.4849 5.51366 13.0688C3.82364 10.46 2.77191 7.48975 2.44366 4.39876C2.41867 4.12222 2.45154 3.84352 2.54016 3.58038C2.62879 3.31724 2.77123 3.07544 2.95843 2.87038C3.14562 2.66531 3.37347 2.50146 3.62745 2.38928C3.88144 2.27709 4.156 2.21902 4.43366 2.21876H7.43366C7.91897 2.21398 8.38946 2.38583 8.75743 2.70229C9.1254 3.01874 9.36574 3.4582 9.43366 3.93876C9.56029 4.89882 9.79511 5.84148 10.1337 6.74876C10.2682 7.10668 10.2973 7.49567 10.2176 7.86964C10.1378 8.2436 9.95253 8.58687 9.68366 8.85876L8.41366 10.1288C9.83722 12.6323 11.9101 14.7052 14.4137 16.1288L15.6837 14.8588C15.9556 14.5899 16.2988 14.4046 16.6728 14.3248C17.0467 14.2451 17.4357 14.2742 17.7937 14.4088C18.7009 14.7473 19.6436 14.9821 20.6037 15.1088C21.0894 15.1773 21.5331 15.422 21.8502 15.7963C22.1673 16.1705 22.3358 16.6483 22.3237 17.1388Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function IconMail({ color = "currentColor", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M4.32324 4.21875H20.3232C21.4232 4.21875 22.3232 5.11875 22.3232 6.21875V18.2188C22.3232 19.3188 21.4232 20.2188 20.3232 20.2188H4.32324C3.22324 20.2188 2.32324 19.3188 2.32324 18.2188V6.21875C2.32324 5.11875 3.22324 4.21875 4.32324 4.21875Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3232 6.21875L12.3232 13.2188L2.32324 6.21875"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function IconArrowRightShort({
  color = "currentColor",
  className = "",
}: {
  color?: string;
  className?: string;
}) {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M5.32324 12.2188H19.3232"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3232 5.21875L19.3232 12.2188L12.3232 19.2188"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function DoorIcon({ color = "#1277FE", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        role="img"
      >
        <path
          d="M20.75 18.4336H18.5V1.93359C18.5 1.53577 18.342 1.15424 18.0607 0.872934C17.7794 0.591629 17.3978 0.433594 17 0.433594H5C4.60218 0.433594 4.22064 0.591629 3.93934 0.872934C3.65804 1.15424 3.5 1.53577 3.5 1.93359V18.4336H1.25C1.05109 18.4336 0.860322 18.5126 0.71967 18.6533C0.579018 18.7939 0.5 18.9847 0.5 19.1836C0.5 19.3825 0.579018 19.5733 0.71967 19.7139C0.860322 19.8546 1.05109 19.9336 1.25 19.9336H20.75C20.9489 19.9336 21.1397 19.8546 21.2803 19.7139C21.421 19.5733 21.5 19.3825 21.5 19.1836C21.5 18.9847 21.421 18.7939 21.2803 18.6533C21.1397 18.5126 20.9489 18.4336 20.75 18.4336ZM17 18.4336H15.5V1.93359H17V18.4336ZM5 1.93359H14V18.4336H5V1.93359ZM12.5 10.5586C12.5 10.7811 12.434 10.9986 12.3104 11.1836C12.1868 11.3686 12.0111 11.5128 11.8055 11.598C11.6 11.6831 11.3738 11.7054 11.1555 11.662C10.9373 11.6186 10.7368 11.5114 10.5795 11.3541C10.4222 11.1968 10.315 10.9963 10.2716 10.7781C10.2282 10.5598 10.2505 10.3336 10.3356 10.1281C10.4208 9.92251 10.565 9.74681 10.75 9.62319C10.935 9.49957 11.1525 9.43359 11.375 9.43359C11.6734 9.43359 11.9595 9.55212 12.1705 9.7631C12.3815 9.97408 12.5 10.2602 12.5 10.5586Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function FilesIcon({ color = "#1277FE", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        role="img"
      >
        <path
          d="M16.5 6.18359H1.5C1.10218 6.18359 0.720644 6.34163 0.43934 6.62293C0.158035 6.90424 0 7.28577 0 7.68359V16.6836C0 17.0814 0.158035 17.4629 0.43934 17.7443C0.720644 18.0256 1.10218 18.1836 1.5 18.1836H16.5C16.8978 18.1836 17.2794 18.0256 17.5607 17.7443C17.842 17.4629 18 17.0814 18 16.6836V7.68359C18 7.28577 17.842 6.90424 17.5607 6.62293C17.2794 6.34163 16.8978 6.18359 16.5 6.18359ZM16.5 16.6836H1.5V7.68359H16.5V16.6836ZM1.5 3.93359C1.5 3.73468 1.57902 3.54392 1.71967 3.40326C1.86032 3.26261 2.05109 3.18359 2.25 3.18359H15.75C15.9489 3.18359 16.1397 3.26261 16.2803 3.40326C16.421 3.54392 16.5 3.73468 16.5 3.93359C16.5 4.13251 16.421 4.32327 16.2803 4.46392C16.1397 4.60458 15.9489 4.68359 15.75 4.68359H2.25C2.05109 4.68359 1.86032 4.60458 1.71967 4.46392C1.57902 4.32327 1.5 4.13251 1.5 3.93359ZM3 0.933594C3 0.734681 3.07902 0.543916 3.21967 0.403264C3.36032 0.262611 3.55109 0.183594 3.75 0.183594H14.25C14.4489 0.183594 14.6397 0.262611 14.7803 0.403264C14.921 0.543916 15 0.734681 15 0.933594C15 1.13251 14.921 1.32327 14.7803 1.46392C14.6397 1.60458 14.4489 1.68359 14.25 1.68359H3.75C3.55109 1.68359 3.36032 1.60458 3.21967 1.46392C3.07902 1.32327 3 1.13251 3 0.933594Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function UserCheckIcon({ color = "#1277FE", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        role="img"
      >
        <path
          d="M19.3688 7.95149C19.1727 7.98431 18.9976 8.09372 18.8821 8.25565C18.7665 8.41757 18.7201 8.61875 18.7529 8.81492C18.8291 9.26972 18.8673 9.73005 18.8673 10.1912C18.8691 12.2107 18.1268 14.1602 16.7823 15.6671C15.9458 14.455 14.7696 13.5173 13.4016 12.9718C14.1365 12.393 14.6727 11.5997 14.9357 10.702C15.1987 9.80437 15.1755 8.84707 14.8692 7.96325C14.563 7.07942 13.9889 6.313 13.2268 5.77057C12.4648 5.22814 11.5527 4.93665 10.6173 4.93665C9.68189 4.93665 8.76975 5.22814 8.00771 5.77057C7.24566 6.313 6.67159 7.07942 6.36532 7.96325C6.05906 8.84707 6.03582 9.80437 6.29884 10.702C6.56186 11.5997 7.09807 12.393 7.8329 12.9718C6.46492 13.5173 5.28874 14.455 4.45227 15.6671C3.39732 14.4783 2.70822 13.0101 2.46781 11.439C2.22741 9.86793 2.44595 8.26084 3.09715 6.81099C3.74835 5.36113 4.80449 4.13025 6.13857 3.26633C7.47266 2.40242 9.02789 1.94226 10.6173 1.94117C11.0784 1.9411 11.5387 1.97936 11.9935 2.05555C12.1888 2.08636 12.3884 2.03882 12.5488 1.92326C12.7092 1.8077 12.8175 1.63347 12.8501 1.43847C12.8828 1.24347 12.8371 1.04348 12.723 0.881995C12.6089 0.720513 12.4357 0.610602 12.241 0.576173C10.2043 0.233531 8.11128 0.547049 6.26431 1.47146C4.41733 2.39587 2.91193 3.88334 1.96545 5.71911C1.01897 7.55487 0.680387 9.64393 0.998595 11.6847C1.3168 13.7254 2.27533 15.6122 3.73579 17.0727C5.19624 18.5331 7.08305 19.4916 9.12378 19.8099C11.1645 20.1281 13.2536 19.7895 15.0893 18.843C16.9251 17.8965 18.4126 16.3911 19.337 14.5441C20.2614 12.6972 20.5749 10.6042 20.2323 8.56742C20.1994 8.37125 20.09 8.19615 19.9281 8.08064C19.7662 7.96513 19.565 7.91867 19.3688 7.95149ZM7.61727 9.44117C7.61727 8.84783 7.79322 8.26781 8.12286 7.77446C8.45251 7.28112 8.92104 6.8966 9.46922 6.66953C10.0174 6.44247 10.6206 6.38306 11.2025 6.49882C11.7845 6.61457 12.319 6.90029 12.7386 7.31985C13.1582 7.73941 13.4439 8.27396 13.5596 8.8559C13.6754 9.43785 13.616 10.041 13.3889 10.5892C13.1618 11.1374 12.7773 11.6059 12.284 11.9356C11.7906 12.2652 11.2106 12.4412 10.6173 12.4412C9.82162 12.4412 9.05856 12.1251 8.49595 11.5625C7.93334 10.9999 7.61727 10.2368 7.61727 9.44117ZM5.56227 16.7068C6.10484 15.8582 6.85228 15.1599 7.7357 14.6762C8.61912 14.1925 9.6101 13.939 10.6173 13.939C11.6245 13.939 12.6154 14.1925 13.4988 14.6762C14.3823 15.1599 15.1297 15.8582 15.6723 16.7068C14.227 17.8308 12.4482 18.4411 10.6173 18.4411C8.78631 18.4411 7.00758 17.8308 5.56227 16.7068ZM20.8979 2.4718L17.8979 5.4718C17.8282 5.54153 17.7455 5.59685 17.6545 5.63459C17.5634 5.67234 17.4658 5.69176 17.3673 5.69176C17.2687 5.69176 17.1711 5.67234 17.0801 5.63459C16.989 5.59685 16.9063 5.54153 16.8366 5.4718L15.3366 3.9718C15.267 3.90212 15.2117 3.81939 15.174 3.72835C15.1363 3.6373 15.1169 3.53972 15.1169 3.44117C15.1169 3.34263 15.1363 3.24505 15.174 3.154C15.2117 3.06296 15.267 2.98023 15.3366 2.91055C15.4774 2.76982 15.6683 2.69076 15.8673 2.69076C15.9658 2.69076 16.0634 2.71017 16.1544 2.74788C16.2455 2.78559 16.3282 2.84087 16.3979 2.91055L17.3673 3.88086L19.8366 1.41055C19.9063 1.34087 19.9891 1.28559 20.0801 1.24788C20.1711 1.21017 20.2687 1.19076 20.3673 1.19076C20.4658 1.19076 20.5634 1.21017 20.6544 1.24788C20.7455 1.28559 20.8282 1.34087 20.8979 1.41055C20.9676 1.48023 21.0229 1.56296 21.0606 1.654C21.0983 1.74505 21.1177 1.84263 21.1177 1.94117C21.1177 2.03972 21.0983 2.1373 21.0606 2.22835C21.0229 2.31939 20.9676 2.40212 20.8979 2.4718Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function BriefcaseIcon({ color = "#1277FE", className = "" }: { color?: string; className?: string }) {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        role="img"
      >
        <path
          d="M18.25 5.30859H14.5C14.5 4.11512 14.0259 2.97053 13.182 2.12661C12.3381 1.2827 11.1935 0.808594 10 0.808594C8.80653 0.808594 7.66193 1.2827 6.81802 2.12661C5.97411 2.97053 5.5 4.11512 5.5 5.30859H1.75C1.35218 5.30859 0.970644 5.46663 0.68934 5.74793C0.408035 6.02924 0.25 6.41077 0.25 6.80859V18.0586C0.25 18.4564 0.408035 18.8379 0.68934 19.1193C0.970644 19.4006 1.35218 19.5586 1.75 19.5586H18.25C18.6478 19.5586 19.0294 19.4006 19.3107 19.1193C19.592 18.8379 19.75 18.4564 19.75 18.0586V6.80859C19.75 6.41077 19.592 6.02924 19.3107 5.74793C19.0294 5.46663 18.6478 5.30859 18.25 5.30859ZM10 2.30859C10.7956 2.30859 11.5587 2.62466 12.1213 3.18727C12.6839 3.74988 13 4.51294 13 5.30859H7C7 4.51294 7.31607 3.74988 7.87868 3.18727C8.44129 2.62466 9.20435 2.30859 10 2.30859ZM18.25 18.0586H1.75V6.80859H18.25V18.0586Z"
          fill={color}
        />
      </svg>
    </>
  );
}
